import React from "react";
import { Routes, Route, Outlet } from "react-router-dom";
import HomeMain from './app/Home'
import Help from './app/Help'
import HelpDetail from './app/HelpDetail'
import HelpCenter from './app/HelpCenter'
import HelpCenterDetail from './app/HelpCenterDetail'
import NotFound from './app/NotFound/index'
import Footer from './components/Footer';
import StubPage from './app/Stub';
import Terms from './app/Terms';
import About from './app/About';

const Layout = ({ childProps }) => (
  <>
    <Outlet />
    <Footer />
  </>
);

const RootRoute = ({ childProps }) => (
  <Routes>
    <Route element={<Layout childProps={childProps} />}>
      <Route path="/" element={<HomeMain {...childProps}/>}/>
      <Route path="/help" element={<Help {...childProps}/>}/>
      <Route path="/HelpDetail/:id" element={<HelpDetail {...childProps}/>}/>
      <Route path="/helpcenter" element={<HelpCenter {...childProps}/>}/>
      <Route path="/helpcenter/:category/:id" element={<HelpCenterDetail {...childProps}/>}/>
      <Route path="/features" element={<StubPage title="功能介绍" />}/>
      <Route path="/tutorials" element={<StubPage title="使用教程" />}/>
      <Route path="/about" element={<About />}/>
      <Route path="/terms" element={<Terms />}/>
      <Route path="/privacy" element={<StubPage title="隐私政策" />}/>
      <Route path="/changelog" element={<StubPage title="更新日志" />}/>
      <Route path="/videos" element={<StubPage title="视频教程" />}/>
      <Route path="/contact" element={<StubPage title="联系我们" image="/assets/code3.563ecfb.jpg"/>}/>
      <Route path="/scenes" element={<StubPage title="使用场景" />}/>
      <Route path="/faq" element={<StubPage title="常见问题" />}/>
    </Route>
    <Route element={<Layout childProps={childProps} />}>
      <Route element={<NotFound/>} />
    </Route>
  </Routes>
);

export default RootRoute;
